import { useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useApiMutation } from '@/api/hooks/useMutation';
import { campaignKeys } from '@/api/queryKeys';
import type { CampaignServiceCampaignDetail } from '@/api';

type Request = { campaignId: number; casProductId: number };

export function useUnreserveProduct() {
  const queryClient = useQueryClient();

  return useApiMutation<void, AxiosError, Request>({
    mutationFn:
      (api) =>
      async ({ campaignId, casProductId }) => {
        await api.campaigns.campaignsControllerUnreserveProduct(campaignId, casProductId);
      },
    onSuccess: (_data, { campaignId, casProductId }) => {
      // Drop the reservation from cache immediately so the UI unblocks without waiting for the refetch.
      queryClient.setQueryData<CampaignServiceCampaignDetail>(
        campaignKeys.detail(campaignId),
        (old) => {
          if (!old) return old;
          return {
            ...old,
            userProducts: old.userProducts.filter((p) => p.casProductId !== casProductId),
          };
        }
      );
      queryClient.invalidateQueries({ queryKey: campaignKeys.detail(campaignId) });
      queryClient.invalidateQueries({ queryKey: campaignKeys.lists() });
    },
  });
}
